<div class="row container_fieldset">
  <fieldset class="form-group">
    <legend>Negoziazione</legend>
    <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
         [labelInput]="'Tipo negoziazione'"
         [valueInput]="ctxBodyFascicolo.fascicolo.tipoNegoziazione ? ctxBodyFascicolo.fascicolo.tipoNegoziazione.label : ''"></div>
    <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data termine concordato'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataTermineConcordato"></div>
  </fieldset>
</div>
<div class="row container_fieldset">
  <fieldset class="form-group">
    <legend>Invito alla negoziazione</legend>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data invio invito'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataInvioInvito"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data ricezione invito'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataRicezioneInvito"></div>
    <div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
         [labelInput]="'Data risposta invito'"
         [valueInput]="ctxBodyFascicolo.fascicolo.dataRispostaInvito"></div>
  </fieldset>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
